/** UKBA Trendyol katalog eşlemesi — mevcut listeyle eşlenmiş mi? */

export function isTrendyolProductMatched(doc) {
  if (!doc || typeof doc !== 'object') return false;
  return String(doc.ty_syncMode || '').trim().toLowerCase() === 'matched';
}
